// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25cXW","content":"styles_content__259hS"};